import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import formMessages from '../../../../../../../intl/admin/solutionGroupMessages';
import PropTypes from 'prop-types';
import {change, formValueSelector, getFormInitialValues, getFormValues} from 'redux-form';
import { withRouter } from 'react-router-dom';
import {
    FORM_FIELD_SG_ADMINS,
    FORM_FIELD_SG_MANUAL_ADMIN_LIST,
    FORM_LABEL_SG_ADMINS,
    FORM_SOLUTION_GROUP_ADMIN_SECTION,
} from '../../../../../../../constants/formConstants';
import {handleFetchUsersError} from '../../../../../../../actions/actionRole';
import {handleAdminSearch} from '../../../../../../../utils/userUtils';
import {debounce} from 'throttle-debounce';
import {DEFAULT_DEBOUNCE_TIMEOUT} from '../../../../../../../constants/validationConstants';
import AsyncSelect from 'react-select/lib/Async';
import BorderRadius from '../../../../../../common/styled/BorderRadius';
import Label from '../../../../../../common/styled/Label';

class AdminSection extends Component {

    loadOptions = (input, callBack) => {
        const {handleFetchUsersError, domain} = this.props;
        handleAdminSearch(input, callBack, handleFetchUsersError, domain);
    }

    filterDuplicity = newOptions => {
        const optionsWithFilteredFields = newOptions.map(item => ({value: item.value, label: item.label, mail: item.mail}));
        const optionsUnique = [...new Map(optionsWithFilteredFields.map(item => [item['value'], item])).values()];

        this.props.change(`${FORM_SOLUTION_GROUP_ADMIN_SECTION}.${FORM_FIELD_SG_ADMINS}`, optionsUnique);
    };

    render() {
        const { readOnly, adminList = '' } = this.props;

        return (
            <>
                <hr />
                <BorderRadius size={5} className="border border-secondary px-4 py-2 bg-white">
                    <div className="row mb-sm-2">
                        <Label bold>
                            <FormattedMessage {...formMessages[FORM_LABEL_SG_ADMINS]} />
                        </Label>
                    </div>
                    <div className="form-row">
                        <div className="col">
                            <AsyncSelect
                                field={FORM_FIELD_SG_MANUAL_ADMIN_LIST}
                                value={adminList}
                                loadOptions={debounce(DEFAULT_DEBOUNCE_TIMEOUT, this.loadOptions)}
                                onChange={this.filterDuplicity}
                                isDisabled={readOnly}
                                isMulti
                            />
                        </div>
                  </div>
                </BorderRadius>
            </>
        )
    }
}

AdminSection.propTypes = {
    intl: PropTypes.object.isRequired,
};

const mapStateToProps = (state, initialProps) => ({
    formValues: getFormValues(initialProps.form)(state),
    initialValues: getFormInitialValues(initialProps.form)(state, `adminSection`),
    userDetail: state.profile.userDetail,
    adminList: formValueSelector(initialProps.form)(state, `${FORM_SOLUTION_GROUP_ADMIN_SECTION}.${FORM_FIELD_SG_ADMINS}`),
});

const mapDispatchToProps = (dispatch, props) => ({
    change: (name, value) => dispatch(change(props.form, name, value)),
    handleFetchUsersError,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(AdminSection)));
